module.exports = __webpack_public_path__ + "img/staffico.1c0bf989.webp";